var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xxl-4 order-1 order-xxl-2"},[_c('StatsWidget7'),_c('StatsWidget12')],1),_c('div',{staticClass:"col-xxl-8 order-1 order-xxl-2"},[_c('AdvancedTableWidget3')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }